import { render } from "./StockNotificationCompact.vue?vue&type=template&id=005fd31f&scoped=true"
import script from "./StockNotificationCompact.vue?vue&type=script&lang=js"
export * from "./StockNotificationCompact.vue?vue&type=script&lang=js"

import "./StockNotificationCompact.vue?vue&type=style&index=0&id=005fd31f&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-005fd31f"]])

export default __exports__